import Hero from "../Hero/Hero";
import TestimonialsCarousel from "../Carousel/TestimonialsCarousel";
import ServiceCards from "../Cards/ServiceCards";
import Consultation from "../Consultation/Consultation";
import "../../styles/main.scss";

const Home = ({ contactRef }) => (
  <div className="App">
    <Hero />
    <ServiceCards />
    <TestimonialsCarousel />
    <Consultation contactRef={contactRef} />
  </div>
);

export default Home;
